import {injectable} from "inversify";
import {Listener} from "@/store/listener";
import {Player} from "@/store/player/types";
import SceneUtils from "@/utils/scene-utils";
import ListenerManager from "@/managers/listener-manager";
import {NotificationPanel} from "@/scenes.ui/notification-panel";
import {Keys} from "@/constants/key";
import SoundUtils from "@/utils/sound-utils";
import PlayerStore from "@/store/player";
import ForceStore from "@/store/force";
import {ForceUpdatesPanel} from "@/scenes.ui/force-updates-panel";
import {ForceNotification} from "@/store/artifact/types";
import {ForceNotificationPanel} from "@/scenes.ui/force-notification-panel";

@injectable()
export class ForceNotificationService implements Listener {

    private timerId: number | undefined = undefined;

    private static getRefreshInterval(player: Player) {
        // 10 minutes
        return 600000;
    }

    public setupScheduledTask() {

        if (!this.timerId) {

            let player: Player = PlayerStore.getPlayer()!;
            if (player.forceNotifications && player.forceNotifications.length > 0) {
                SceneUtils.getCurrentScene().time.delayedCall(500, () => {
                    let openingSound = SoundUtils.addSound(SceneUtils.getCurrentScene(), Keys.SOUND_AWARD);
                    let clickSound = SoundUtils.addSound(SceneUtils.getCurrentScene(), Keys.SOUND_BUTTON_CLICK);
                    let uap: ForceUpdatesPanel = new ForceUpdatesPanel(SceneUtils.getCurrentScene(), SceneUtils.getCanvas(),
                        player.forceNotifications, openingSound, clickSound);
                    ForceStore.clearForceNotifications().then(() => {
                        uap.open();
                    });
                });
            }

            this.timerId = setInterval(() => {
                this.job();
            }, ForceNotificationService.getRefreshInterval(player));
            ListenerManager.addPlayerListener(this);
        }
    }

    onChange(): void {
        ForceNotificationService.showNotification();
    }

    private job() {
        ForceStore.isTimeToActualize().then((isTime: boolean) => {
            if (isTime) {
                ForceStore.actualizeForces();
            }
        });
    }

    private static showNotification() {
        let player: Player = PlayerStore.getPlayer()!;
        if (player.forceNotifications && player.forceNotifications.length > 0) {
            let notification = player.forceNotifications[0];
            let uap: ForceNotificationPanel = new ForceNotificationPanel(SceneUtils.getCurrentScene(), SceneUtils.getCanvas(), notification);
            ForceStore.deleteForceNotification(notification.id).then(() => {
                uap.open();
            });
        }
    }

}
